import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

export default {
  popper: css`
    z-index: 2;
  `,
  popperOverflow: (theme: Theme) => css`
    z-index: 2;
    max-height: ${theme.mui.spacing(32)}px;
    overflow-y: auto;
  `,
};
